const data = [
    { id: 'BACKOFFICE', name: 'Backoffice' },
    { id: 'CLIENT', name: 'Provedor' }
];

export default [...data];